import { download_csv_file, init_gradient_table } from 'amt_admin/utils';

const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope',
        'jsonrpc',
        'chartFilters',
        function($scope, jsonrpc, chartFilters) {
            function set_table_data(resp) {
                Object.assign($scope.vm, resp);
                const rows = resp.rows.map(row => _.pick(row, ...resp.columns));
                table.set_rows(rows);
            }
            function update_attribution_table(model) {
                return jsonrpc.callServiceMethod('retention.attribution_table', model).then(set_table_data);
            }

            const table = init_gradient_table();
            $scope.get_bg_color = table.get_bg_color;
            $scope.download_players_csv = function () {
                download_csv_file('attribution_players', $scope.vm.players_csv);
            };
            $scope.vm = {};
            update_attribution_table(chartFilters.get_chart_filters());
            chartFilters.onChangeChartParams('update_attribution_table', update_attribution_table);
        },
    ],
};
const state_config = {
    url: '/attribution',
    reloadOnSearch: false,
    data: {
        priority: 900,
        title: 'Attribution',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
